import { render, staticRenderFns } from "./history_EditUser.vue?vue&type=template&id=24cc27b8&scoped=true&"
import script from "./history_EditUser.vue?vue&type=script&lang=js&"
export * from "./history_EditUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24cc27b8",
  null
  
)

export default component.exports